<template>
  <div>
    <span class="sr-only">{{ $t(`white-label.components.trendArrow.${orientation}`) }}</span>
    <div class="c-trend-arrow" :class="[orientation]">
      <i class="fas fa-caret-up" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'c-trend-arrow',
  props: {
    orientation: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/styles/components/custom/c-trend-arrow';
</style>
